import PropTypes from 'prop-types';
import Revenue from "./components/Revenue"
import SiteHistory from './components/SiteHistory';
import EnergyUsage from './components/EnergyUsage';
import ReimbursementDue from './components/ReimbursementDue';

const MS = ({statement}) => {

  const reimbursementDue = statement.data.grossRevenue - statement.data.grossServiceFee;

  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyUsage data={statement.data}/>
      <Revenue data={statement.data}/>
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default MS;

MS.propTypes = {
  statement: PropTypes.object.isRequired,
};